import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/content';
import { Countdown } from './Countdown';
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" aria-labelledby="bonos-title" data-id="element-10" data-mp="plskk5gd729r">
      <div className="mx-auto max-w-5xl px-5" data-id="element-11" data-mp="at8ti36hol8o">
        <div className="text-center" data-id="element-12" data-mp="ft4qvjkolef9">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-olive" data-id="element-13" data-mp="fs3bx40jo7s9">
            Incluido sin costo
          </span>
          <h2 id="bonos-title" className="mt-3 font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl" data-id="element-14" data-mp="5wi4urgmchbn">
            Bonos de regalo
          </h2>
        </div>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-15" data-mp="3szwqf5rdy239">
          {bonuses.map((bonus, index) => <motion.li key={bonus.label} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.06
        }} className="flex items-start gap-4 rounded-2xl border border-sage/70 bg-sage-mist p-6 shadow-card" data-id="element-16" data-mp="1mb9z79xbrynl" data-mpi={index}>
              <span className="text-2xl" aria-hidden="true" data-id="element-17" data-mp="3r5ouzjf501kj">
                🎁
              </span>
              <div data-id="element-18" data-mp="3n67qotbg5agy">
                <span className="block text-[11px] font-bold uppercase tracking-[0.18em] text-olive" data-id="element-19" data-mp="3n5ohq23rxwf2">
                  {bonus.label}
                </span>
                <p className="mt-1 font-display text-base font-bold leading-snug text-black" data-id="element-20" data-mp="2uh0q7osfmat2">
                  {bonus.title}
                </p>
              </div>
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-lg" data-id="element-21" data-mp="33gw5a4p3ypyd">
          <Countdown data-id="element-22" data-mp="33j9ys9453u3t" />
        </div>
      </div>
    </section>;
}